module.exports = __webpack_public_path__ + "99c76f2c1cd6437954f62132231da2ac.jpg";